module.exports = __webpack_public_path__ + "img/labs1_3.5830bf5a.svg";